import { checkHasPermission, PERMISSION_CODES } from "../store/permission"

export function canViewDashboard(user) {
    return Boolean(checkHasPermission({
        isAdmin: Boolean(user?.isAdmin),
        permissionId: PERMISSION_CODES.CMS_VIEW_REPORT_SALES_REPORT,
        userPermissionIds: user?.permissionIds || [],
    }))
}
